import { createRouter, createWebHashHistory } from 'vue-router';
import store from '../store'
// import Index from '@/views/Index.vue';
// import Preview from '@/views/Preview.vue';
// import Manager from '@/views/Manager.vue';
// import Deploy from '@/views/Deploy.vue';
const routes = [{
        path: '/',
        name: 'Manager',
        component: () =>
            import ( /* webpackChunkName: "manager" */ '@/views/Manager.vue'),
    },
    {
        path: '/index',
        name: 'Index',
        component: () =>
            import ( /* webpackChunkName: "manager" */ '@/views/Index.vue'),
        // component: Index,
    },
    {
        path: '/preview',
        name: 'Preview',
        component: () =>
            import ( /* webpackChunkName: "preview" */ '@/views/Preview.vue'),
        // component: Preview,
    },

    // {
    //   path: '/manager',
    //   name: 'Manager',
    //   component: () => import(/* webpackChunkName: "manager" */ '@/views/Preview.vue'),

    // },

    {
        path: '/deploy',
        name: 'Deploy',
        component: () =>
            import ( /* webpackChunkName: "deploy" */ '@/views/Deploy.vue'),
    },
    {
        path: '/loginpage',
        name: 'loginpage',
        component: () =>
            import ( /* webpackChunkName: "deploy" */ '@/login/login.vue'),
    },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});
router.beforeEach((to, from, next) => {
        // console.log((to.name !== 'loginpage' && !store.state.login_status)||!store.state.isInIframe); &&!store.state.isInIframe
        const isHaveUserInfo = localStorage.getItem('origin_userInfo')
        if(to.name=='Deploy'){
            next()
        }
        else if ((to.name !== 'loginpage' && !isHaveUserInfo && !store.state.isInIframe && !store.state.login_status)) {
            next({ name: 'loginpage' })
        } else {
            next()
        }
    })
    // 添加全局守卫
    // router.beforeEach(async () => {
    //   // function getUrlParam(name) {
    //   //   let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    //   //   let r = window.location.search.substr(1).match(reg);
    //   //   if (r != null) return unescape(r[2]);
    //   //   return null;
    //   // }
    //   // console.log('vue router');
    //   // let redirectUrl = window.document.location.href;
    //   // console.log('vue router', redirectUrl);
    //   // let pathName = this.$route.href;
    //   // let pos = url.indexOf(pathName);
    //   // let redirectUrl = url.substring(0, pos); //encodeURIComponent(document.URL);
    //   // redirectUrl = redirectUrl.split('?')[0];
    //   // const userInfo = window.localStorage.getItem('userInfo');
    //   // if (!userInfo) {
    //   //   window.location =
    //   //     'http://sso.likezou.com:8080/oauth/authorize?client_id=appid&redirect_uri=' +
    //   //     redirectUrl +
    //   //     '&response_type=code&scope=read';
    //   // } else {
    //   return true;
    //   // }
    // });

export default router;